import React from 'react';
import { StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { Event, Market, Player } from '@/feature/event-details-sbk/types';
import { formatPlayerName } from '@/utils/format-player-name';

import { OPTION_BUTTON_HEIGHT, OptionButton, getBorderRadiusStyle } from '../../OptionButton';
import { PlayerLogoImage } from './PlayerLogoImage';

const BUTTON_MIN_WIDTH = 80;

type PlayerPropListLayoutProps = {
    market: Market;
    event: Event;
    player: Player;
    rowIndex: number;
    rowCount: number;
};

export const PlayerPropListLayout = ({ market, event, player, rowIndex, rowCount }: PlayerPropListLayoutProps) => {
    const option = getListOption(market);
    const buttonStyle = [styles.button, getBorderRadiusStyle(rowIndex, 0, rowCount, 1)];

    return (
        <Row alignItems="center" gap="s16" pb="s3">
            <PlayerLogoImage player={player} />
            <Box flex={1}>
                <Text variant="titleMedium" numberOfLines={1}>
                    {formatPlayerName({ firstName: player.first_name, lastName: player.last_name })}
                </Text>
                <Text color="neutral300" variant="bodySmall" numberOfLines={1}>
                    {player.team.name}
                </Text>
            </Box>
            {option ? (
                <Box minWidth={BUTTON_MIN_WIDTH} height={OPTION_BUTTON_HEIGHT}>
                    <OptionButton market={market} option={option} event={event} buttonStyle={buttonStyle} />
                </Box>
            ) : null}
        </Row>
    );
};

const getListOption = (market: Market) => {
    if (market.options.length > 1) {
        // ignore the NO option
        return market.options.find(op => op.option_type.code === 'YES');
    }
    return market.options[0];
};

const styles = StyleSheet.create({
    button: {
        paddingHorizontal: 12,
    },
});
